import { PaymentMethod } from '@wix/cashier-common/dist/src/enums/payments/PaymentMethod';
import { ServerTransactionStatus } from '@wix/cashier-common/dist/src/enums/transactions/ServerTransactionStatus';
import { getBiLogger } from '../../utils/biLogger';
import { AsyncPaymentResult } from '../types/AsyncPaymentResult';
import { PayModalParams } from '../types/PayModal';
import { ServerErrorCode } from './serverErrorMapping';
import { isSuccessfulServerStatus } from './statusUtils';

export const openPaymentInModal = (
  openPayModal: (params: PayModalParams) => void,
  params: {
    paymentMethod: PaymentMethod;
    providerPageUrl: string;
    responsive: boolean;
  }
): Promise<AsyncPaymentResult> => {
  const { paymentMethod, providerPageUrl, responsive = true } = params;

  if (paymentMethod === PaymentMethod.CreditCard) {
    getBiLogger().transaction3dsForm({ isOpened: true });
  }

  return new Promise<AsyncPaymentResult>((resolve) => {
    openPayModal({
      url: providerPageUrl,
      paymentMethod,
      responsive,

      onResponse: (response) => {
        if (paymentMethod === PaymentMethod.CreditCard) {
          getBiLogger().transaction3dsForm({
            isFinished: isSuccessfulServerStatus(response.status),
          });
        }

        resolve(response);
      },

      onManualClose: () => {
        if (paymentMethod === PaymentMethod.CreditCard) {
          getBiLogger().transaction3dsForm({ isFinished: false });
        }

        resolve({
          status: ServerTransactionStatus.BuyerCanceled,
          failureCode: ServerErrorCode.BuyerCanceled,
        });
      },
    });
  });
};
